/**
 * Application Version Configuration
 *
 * The constant values below are injected at build time from package.json
 * using Vite's define option. This file itself is not auto-generated or overwritten.
 *
 * To update the version, modify package.json and rebuild the project.
 */

// These will be replaced at build time by Vite

// Declare the Vite-injected globals so TypeScript recognizes them
declare const __APP_VERSION__: string;
declare const __APP_BUILD_NUMBER__: string;
declare const __APP_ENVIRONMENT__: string;

export const APP_VERSION = __APP_VERSION__;
export const APP_BUILD_NUMBER = __APP_BUILD_NUMBER__;
export const APP_ENVIRONMENT = __APP_ENVIRONMENT__;

export interface VersionInfo {
  version: string;
  buildNumber: string;
  environment: string;
}

export function getVersionInfo(): VersionInfo {
  return {
    version: APP_VERSION,
    buildNumber: APP_BUILD_NUMBER,
    environment: APP_ENVIRONMENT,
  };
}
